import { FC, useCallback, useState } from 'react'
import ReactCrop, { Crop, PercentCrop, PixelCrop, centerCrop, makeAspectCrop } from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

type ImageCropProps = {
  image: string
  onCropComplete: (croppedArea: PixelCrop, croppedAreaPixels: PercentCrop) => void
  aspectRatio?: number
  setImageDimensions: (dimensions: { width: number; height: number }) => void
}

const ImageCrop: FC<ImageCropProps> = ({ image, onCropComplete, aspectRatio = 1, setImageDimensions }) => {
  const [crop, setCrop] = useState<Crop>()

  const handleOnCropComplete = useCallback(
    (croppedArea: PixelCrop, croppedAreaPixels: PercentCrop) => {
      onCropComplete(croppedArea, croppedAreaPixels)
    },
    [onCropComplete]
  )

  // This is to demonstate how to make and center a % aspect crop
  // which is a bit trickier so we use some helper functions.
  const centerAspectCrop = (mediaWidth: number, mediaHeight: number, aspect: number) => {
    return centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 45
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    )
  }

  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { clientWidth: width, clientHeight: height } = e.currentTarget

    setCrop(centerAspectCrop(width, height, aspectRatio))
    setImageDimensions({ width, height })
  }

  return (
    <ReactCrop crop={crop} aspect={aspectRatio} onChange={setCrop} onComplete={handleOnCropComplete}>
      <img src={image} onLoad={onImageLoad} />
    </ReactCrop>
  )
}

export default ImageCrop
